<div class="container">
  <div class="icons">
    <span class="item-toggle">Gerar:</span>
    <div class="pdf-icon">
      <a (click)="downloadPdfCursosSubmissao()">
        <i class="fas fa-file-pdf fa-lg"></i>
      </a>
    </div>
    <div class="csv-icon">
      <i class="fas fa-file-csv fa-lg" (click)="downloadCsvCursosSubmissao()"></i>
    </div>
  </div>
  <br />
  <h1 class="title text-center">Tabela de Submissão</h1>

  <p class="text-justify">
    Nesta tabela de submissão estão listados os cursos cuja entrada no Catálogo foi recusada, ou ainda cursos que
    foram retirados do Catálogo por não terem mais oferta. A recusa se deu porque já existe no Catálogo curso com
    formação semelhante, o curso proposto se enquadra como qualificação profissional ou especialização técnica ou ainda
    pode ter sido por conflito com norma regulamentadora de profissão. Desta forma, recomenda-se que tais cursos não
    sejam mais oferecidos, a menos que sejam adaptados para perfis que já constam no Catálogo.

  </p>
  <br />
</div>

<div class="container">
  <table class="table table-bordered">
    <tbody *ngFor="let curso of cursosTabelaSubmissao">
      <tr scope="col" class="bg-color-table-convergencia-title-cursos">
        <td>EIXO TECNOLÓGICO</td>
        <td>DENOMINAÇÕES</td>
      </tr>
      <tr class="coluna-vertical-align-middle">
        <td>{{curso.eixoNome}}</td>
        <td>
          <ul class="course-item" *ngIf="curso.cursosSubmissaoPorEixo && curso.cursosSubmissaoPorEixo.length > 0">
            <li *ngFor="let cursoSubmissao of curso.cursosSubmissaoPorEixo">
              {{cursoSubmissao.nome}}
            </li>
          </ul>
          <ul class="course-item" *ngIf="curso.cursosSubmissaoPorEixo && curso.cursosSubmissaoPorEixo.length < 1">
            <li>
              Não Houve alteração
            </li>
          </ul>
        </td>
      </tr>
      <tr scope="col">
        <td colspan=2></td>
      </tr>
    </tbody>
  </table>
  <ng-container *ngIf="totalResultados > 0">
    <app-paginacao [paginaAtual]="paginaAtual" [totalPaginas]="totalPaginas"
      (mudouPagina)="onPaginaSelecionada($event)"></app-paginacao>
  </ng-container>
</div>